import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class TopListingActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/TopListing/TopListingBrowser")
	}

	render() {
		return (
			<Activity 
				name="TopListing"
				RenderedComponent={this.RenderedComponent}
				context="TopListing"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(TopListingActivity)
